import React, { Component } from 'react';
import firebase from './../Firestore'

// Components
import Categorias from './Categorias';
import Carrito from './Carrito';
import EncabezadoCarrito from './EncabezadoCarrito';
import EstadoPedido from './EstadoPedido';
import EncabezadoPrincipal from './EncabezadoPrincipal';
import MenuPrincipal from './MenuPrincipal';
//import Pedidos from '../Admin/Pedidos'

import store from '../../store';

import { CookiesProvider } from 'react-cookie';

class MarcoItem extends Component {

  _isMounted = false;
  _levantadoAdicionales = false;


  constructor(props) {
    //console.log("MI constru carritoVacio", this.state.carritoVacio)
    super(props);


    this.state = {
      interface: "menuPrincipal",
      vieneDelCarrito: false,
      carritoVacio: true,
      cat: [],
      adicionalDetalle : [],
      seFracciona: true,
      catSeleccionada: "",
      diseno: "",
      productoDetalle: undefined,
      catSeleccionadaMenuPrincipal: false
    }

    store.subscribe(() => {
      this.setState({
        interface: store.getState().interface,
        vieneDelCarrito: store.getState().vieneDelCarrito,
        //carritoVacio: store.getState().carritoVacio,
        catSeleccionadaMenuPrincipal: store.getState().catSeleccionadaMenuPrincipal,
        catSeleccionada: store.getState().catSeleccionadaMenuPrincipal,
      })
    });
  }

componentDidMount(){
  //console.log("did Mount")
  this._isMounted = true;
  if (this._isMounted) {
    //levantar categorias para Menu principal
    let currentComponent = this;
    let db = firebase.firestore()
    db.collection("categoria").orderBy("orden", "asc").get().then((snapShots) => {
          this.setState(
            {
              cat: snapShots.docs.map(doc => {
                return {
                  "nombre": doc.data().nombre,
                  "imagen": doc.data().imagen,
                  "seFracciona": doc.data().seFracciona,
                  "diseno": doc.data().diseno,
                  "id": doc.id}
              })
            }
          );
    });
  }
}


componentDidUpdate(prevProps, prevState) {
  // Typical usage (don't forget to compare props):
  //console.log("did update")
  //console.log("interface de marcoitem", this.state.interface)

  this._isMounted = true;
  if (this._isMounted) {
    let currentComponent = this;
    let db = firebase.firestore()

  if (this.state.interface === "listado" && prevState.interface === "carrito") {
      //console.log("teiene que entrar aca")
        this.setState({
          catSeleccionada: this.state.cat[0].id,
          diseno: "pizza"
         });
  }


  if(!this.state.productoDetalle){
    this.levantarProductoDetalle(db, currentComponent);
    this.verSiHayProductosEnCarrito(db, currentComponent)
    // this.verSiHayProductosEnCariito(db, currentComponent);
    // esta funcion con un onsnapshot de firestore
  }
  if(this.state.adicionalDetalle.length === 0 && this._levantadoAdicionales === false){
    this._levantadoAdicionales = true;
    this.levantarAdicionalDetalle(db, currentComponent)
  }

  }
}


levantarProductoDetalle(db, currentComponent){
  db.collection("producto").where("enStock", "==", true)
      .get()
      .then(function(querySnapshot) {
        var data = querySnapshot.docs.map(function (documentSnapshot) {
          return {id: documentSnapshot.id, data: documentSnapshot.data()};
        });

        currentComponent.setState({productoDetalle: data})

      })
      .catch(function(error) {
          console.log("Error getting documents: ", error);
      });
}

levantarAdicionalDetalle(db, currentComponent){
  //console.log("entra en levantarAdicionalDetalle")
  // adicionales
  db.collection("adicionales")
      .get()
      .then(function(querySnapshot) {
        var data = querySnapshot.docs.map(function (documentSnapshot) {
          return {id: documentSnapshot.id, data: documentSnapshot.data()};
        });

        currentComponent.setState({adicionalDetalle: data})

      })
      .catch(function(error) {
          console.log("Error getting documents: ", error);
      });

}

verSiHayProductosEnCarrito(db, currentComponent){
  // ver si hay productos en carrito
  currentComponent = this
  if(sessionStorage.getItem("nroPedido") !== null){

    db.collection("pedidoDetalle").where("pedidoId", "==", sessionStorage.getItem("nroPedido"))
    .onSnapshot(function(querySnapshot) {
      if(querySnapshot.size > 0){
        currentComponent.setState({carritoVacio: false})
      }else{
        currentComponent.setState({carritoVacio: true})
      }
    });
  }
}

componentWillUnmount() {
  this._isMounted = false;
}

  render() {
    //console.log("render")
    //console.log("this.state.productoDetalle.length", this.state.productoDetalle.length)
    return (
      <div>
        <EncabezadoPrincipal />
          {this.state.carritoVacio === false && this.state.interface !== "carrito" && this.state.interface !== "estadoPedido" &&
            <EncabezadoCarrito />
          }

          {this.state.interface === "menuPrincipal" &&
            <CookiesProvider>
              <MenuPrincipal formato="menuPrincipal" uid={this.props.uid} cat={this.state.cat} vieneDelCarrito={this.state.vieneDelCarrito} carritoVacio={this.state.carritoVacio}/>
              <div className="bg-dark text-white text-center"><a href = "mailto: appNegociosPizza@gmail.com">desarrollo de APPs</a></div>
            </CookiesProvider>
          }


          {this.state.interface === "listado" &&
          <div>

              <Categorias catSeleccionada={this.state.catSeleccionadaMenuPrincipal ? this.state.catSeleccionadaMenuPrincipal : this.state.catSeleccionada} uid={this.props.uid} productoDetalle={this.state.productoDetalle} cat={this.state.cat} vieneDelCarrito={this.state.vieneDelCarrito}/>
          </div>

        }

        {this.state.interface === "carrito" &&

          <Carrito uid={this.props.uid} productoDetalle={this.state.productoDetalle} cat={this.state.cat} adicionalDetalle={this.state.adicionalDetalle} />
        }

        {this.state.interface === "estadoPedido" &&

          <EstadoPedido uid={this.props.uid} productoDetalle={this.state.productoDetalle} cat={this.state.cat} adicionalDetalle={this.state.adicionalDetalle}/>
        }

      </div>
    )
  }
}

export default MarcoItem;
